import get from 'lodash/get';
import set from 'lodash/set';
import ReactDOM from 'react-dom';
import React from 'react';

export default class ReactRenderer {

    static components = {};

    static registerComponent(name, component){
        if(get(ReactRenderer.components, name)){
            return;
        }

        set(ReactRenderer.components, name, component);
    }

    static render() {
        document.querySelectorAll("[data-react-class]").forEach((element) => {
            let components = this.components;

            let Component = get(components, element.dataset.reactClass);
            let props = JSON.parse(element.dataset.reactProps);

            if (typeof Component === 'undefined' || Component === null) {
                return;
            }

            let JSX = (<Component {...props}/>);

            ReactDOM.render(
                JSX,
                element
            );
        });
    }
}